import { render, staticRenderFns } from "./InstitutionalSection.vue?vue&type=template&id=0c9d3e0e&scoped=true"
import script from "./InstitutionalSection.vue?vue&type=script&lang=js"
export * from "./InstitutionalSection.vue?vue&type=script&lang=js"
import style0 from "./InstitutionalSection.vue?vue&type=style&index=0&id=0c9d3e0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9d3e0e",
  null
  
)

export default component.exports